// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"384":"513d2cad","481":"77fc9c28","553":"fdfcb8ad","703":"678eb62a","973":"815c3a0f"}[chunkId] + ".css";
};